module.exports = __webpack_public_path__ + "869bd8d789a79d06cae1452a49f9a31b.svg";